import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedModule } from '../../../core/shared.module';
import { FiltroService } from '../../../service/filtro.service';

@Component({
  selector: 'app-filtro-storico-deleghe',
  standalone: true,
  templateUrl: './filtro-storico-deleghe.component.html',
  imports: [SharedModule],
})
export class FiltroStoricoDelegheComponent {
  form: FormGroup;
  @Output() searchEvent = new EventEmitter();

  mesi = [
    { value: 1, label: 'Gennaio' },
    { value: 2, label: 'Febbraio' },
    { value: 3, label: 'Marzo' },
    { value: 4, label: 'Aprile' },
    { value: 5, label: 'Maggio' },
    { value: 6, label: 'Giugno' },
    { value: 7, label: 'Luglio' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Settembre' },
    { value: 10, label: 'Ottobre' },
    { value: 11, label: 'Novembre' },
    { value: 12, label: 'Dicembre' },
  ];

  constructor(
    private fb: FormBuilder,
    private filtroService: FiltroService,
  ) {
    this.form = this.fb.group({
      anno: [null],
      mese: [null],
      delegante: [''],
      delegato: [''],
    });
  }

  ngOnInit(): void {
    this.filtroService.ultimoFiltroDeleghe.subscribe((filtro) => {
      this.form.patchValue({ ...filtro });
    });
  }

  search(reset?: boolean): void {
    if (reset) {
      this.form.reset();
    }

    const retValue = { ...this.form.value };
    this.filtroService.setUltimoFiltroDeleghe(retValue);
    this.searchEvent.emit(retValue);
  }
}
